import { render, staticRenderFns } from "./bgs.vue?vue&type=template&id=01ee568c"
import script from "./bgs.vue?vue&type=script&lang=js"
export * from "./bgs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports